//import { round } from 'lodash';
//import { QuizSessionAnswer } from '@/app/database/database-models';

// export const calculateScore = (answers: QuizSessionAnswer[]): number => {
//   let score: number = 0;
//   answers.forEach((answer: QuizSessionAnswer) => score += answer.score);
//   return round(score, 1);
// };

export const isQuiz = (): boolean => {
  return $('.quiz.component').length > 0;
};
